export enum LimitConfigV2ReduxTypes {
  FETCH_LIST_APPROVED_LIMITS_V2 = '@@limitConfigV2/FETCH_LIST_APPROVED_LIMITS_V2',
  FETCH_LIST_APPROVED_LIMITS_V2_SUCCESS = '@@limitConfigV2/FETCH_LIST_APPROVED_LIMITS_V2_SUCCESS',
  FETCH_LIST_APPROVED_LIMITS_V2_ERROR = '@@limitConfigV2/FETCH_LIST_APPROVED_LIMITS_V2_ERROR',
  RESET_LIST_APPROVED_LIMITS_V2 = '@@limitConfigV2/RESET_LIST_APPROVED_LIMITS_V2',

  FETCH_LATEST_VERSION_LIMITS_V2 = '@@limitConfigV2/FETCH_LATEST_VERSION_LIMITS_V2',
  FETCH_LATEST_VERSION_LIMITS_V2_SUCCESS = '@@limitConfigV2/FETCH_LATEST_VERSION_LIMITS_V2_SUCCESS',
  FETCH_LATEST_VERSION_LIMITS_V2_ERROR = '@@limitConfigV2/FETCH_LATEST_VERSION_LIMITS_V2_ERROR',
  RESET_LATEST_VERSION_LIMITS_V2 = '@@limitConfigV2/RESET_LATEST_VERSION_LIMITS_V2',

  CREATE_DRAFT_LIMIT_V2 = '@@limitConfigV2/CREATE_DRAFT_LIMIT_V2',
  CREATE_DRAFT_LIMIT_V2_SUCCESS = '@@limitConfigV2/CREATE_DRAFT_LIMIT_V2_SUCCESS',
  CREATE_DRAFT_LIMIT_V2_ERROR = '@@limitConfigV2/CREATE_DRAFT_LIMIT_V2_ERROR',
  RESET_CREATE_DRAFT_LIMIT_V2 = '@@limitConfigV2/RESET_CREATE_DRAFT_LIMIT_V2',

  PUBLISH_LIMIT_V2 = '@@limitConfigV2/PUBLISH_LIMIT_V2',
  PUBLISH_LIMIT_V2_SUCCESS = '@@limitConfigV2/PUBLISH_LIMIT_V2_SUCCESS',
  PUBLISH_LIMIT_V2_ERROR = '@@limitConfigV2/PUBLISH_LIMIT_V2_ERROR',
  RESET_PUBLISH_LIMIT_V2 = '@@limitConfigV2/RESET_PUBLISH_LIMIT_V2',

  UPDATE_DRAFT_LIMIT_V2 = '@@limitConfigV2/UPDATE_DRAFT_LIMIT_V2',
  UPDATE_DRAFT_LIMIT_V2_SUCCESS = '@@limitConfigV2/UPDATE_DRAFT_LIMIT_V2_SUCCESS',
  UPDATE_DRAFT_LIMIT_V2_ERROR = '@@limitConfigV2/UPDATE_DRAFT_LIMIT_V2_ERROR',
  RESET_UPDATE_DRAFT_LIMIT_V2 = '@@limitConfigV2/RESET_UPDATE_DRAFT_LIMIT_V2',

  APPROVE_LIMIT_V2 = '@@limitConfigV2/APPROVE_LIMIT_V2',
  APPROVE_LIMIT_V2_SUCCESS = '@@limitConfigV2/APPROVE_LIMIT_V2_SUCCESS',
  APPROVE_LIMIT_V2_ERROR = '@@limitConfigV2/APPROVE_LIMIT_V2_ERROR',
  RESET_APPROVE_LIMIT_V2 = '@@limitConfigV2/RESET_APPROVE_LIMIT_V2',

  REJECT_LIMIT_V2 = '@@limitConfigV2/REJECT_LIMIT_V2',
  REJECT_LIMIT_V2_SUCCESS = '@@limitConfigV2/REJECT_LIMIT_V2_SUCCESS',
  REJECT_LIMIT_V2_ERROR = '@@limitConfigV2/REJECT_LIMIT_V2_ERROR',
  RESET_REJECT_LIMIT_V2 = '@@limitConfigV2/RESET_REJECT_LIMIT_V2',

  DELETE_LIMIT_V2 = '@@limitConfigV2/DELETE_LIMIT_V2',
  DELETE_LIMIT_V2_SUCCESS = '@@limitConfigV2/DELETE_LIMIT_V2_SUCCESS',
  DELETE_LIMIT_V2_ERROR = '@@limitConfigV2/DELETE_LIMIT_V2_ERROR',
  RESET_DELETE_LIMIT_V2 = '@@limitConfigV2/RESET_DELETE_LIMIT_V2',

  DELETE_LIMIT_V2_BY_EXTERNAL_ID = '@@limitConfigV2/DELETE_LIMIT_V2_BY_EXTERNAL_ID',
  DELETE_LIMIT_V2_BY_EXTERNAL_ID_SUCCESS = '@@limitConfigV2/DELETE_LIMIT_V2_BY_EXTERNAL_ID_SUCCESS',
  DELETE_LIMIT_V2_BY_EXTERNAL_ID_ERROR = '@@limitConfigV2/DELETE_LIMIT_V2_BY_EXTERNAL_ID_ERROR',
  RESET_DELETE_LIMIT_V2_BY_EXTERNAL_ID = '@@limitConfigV2/RESET_DELETE_LIMIT_V2_BY_EXTERNAL_ID',

  FREEZE_LIMIT_V2 = '@@limitConfigV2/FREEZE_LIMIT_V2',
  FREEZE_LIMIT_V2_SUCCESS = '@@limitConfigV2/FREEZE_LIMIT_V2_SUCCESS',
  FREEZE_LIMIT_V2_ERROR = '@@limitConfigV2/FREEZE_LIMIT_V2_ERROR',
  RESET_FREEZE_LIMIT_V2 = '@@limitConfigV2/RESET_FREEZE_LIMIT_V2',

  UNFREEZE_LIMIT_V2 = '@@limitConfigV2/UNFREEZE_LIMIT_V2',
  UNFREEZE_LIMIT_V2_SUCCESS = '@@limitConfigV2/UNFREEZE_LIMIT_V2_SUCCESS',
  UNFREEZE_LIMIT_V2_ERROR = '@@limitConfigV2/UNFREEZE_LIMIT_V2_ERROR',
  RESET_UNFREEZE_LIMIT_V2 = '@@limitConfigV2/RESET_UNFREEZE_LIMIT_V2',
}

export type LimitHistoryV2 = {
  id: string;
  limitId: string;
  customerRelationId: string | null;
  businessDate: string;
  normalOperativeAmount: number;
  normalAdjustmentAmount: number;
  normalUtilizedAmount: number;
  normalAvailableAmount: number;
  adhocOperativeAmount: number;
  adhocAdjustmentAmount: number;
  adhocUtilizedAmount: number;
  adhocAvailableAmount: number;
  adjustedByEntityName: string | null;
  adjustedByEntityId: string | null;
  adjustedAt: string | null;
  status: string;
  eventType: string;
  createdOn: number;
  updatedOn: number;
};

export type CurrencyV2 = {
  id: string;
  externalId: string;
  shortCode: string;
  longName: string;
  numOfDecimalPlaces?: number;
  status?: string;
};

export type ProductTypeV2 = {
  id: string;
  externalId: string;
  productType: string;
  status?: number | string;
};

export type CustomerV2 = {
  id: string;
  externalId: string;
  fullName: string;
  tradeName?: string;
};

export type UserV2 = {
  id: string;
  externalId: string;
  email: string;
  name: string;
};

export type NonAggregateLimitV2 = {
  limitId: string;
  externalId: string;
  status: string;
  createdByUser: UserV2;
  actionByUserRecord: UserV2;
  customer: CustomerV2;
  customerName: string;
  productType: ProductTypeV2 | null;
  parentAggregateId: string | null;
  currency: CurrencyV2;
  normalSanctionedAmount: number;
  normalOperativeAmount: number;
  normalEffectiveUpto: string;
  normalEffective: boolean;
  normalAvailableAmount: number;
  adhocSanctionedAmount: number | null;
  adhocEffectiveUpto: string | null;
  adhocAvailableAmount: number | null;
  adhocEffective: boolean;
  createdBy: string;
  checkerRemarks: string;
  makerRemarks: string;
  draft: boolean;
  blocked: boolean;
  freeze: boolean;
  inactiveReason: string | null;
  isDisabled: boolean;
  createdOn: number;
  updatedOn: number;
  history: LimitHistoryV2 | null;
};

export type AggregateLimitV2 = {
  id: string;
  externalId: string;
  status: string;
  createdByUser: UserV2;
  actionByUserRecord: UserV2;
  customer: CustomerV2;
  customerName: string;
  productType: ProductTypeV2 | null;
  parentAggregateId: string | null;
  currency: CurrencyV2;
  normalSanctionedAmount: number;
  normalOperativeAmount: number;
  normalAvailableAmount: number;
  normalEffectiveUpto: string;
  normalEffective: boolean;
  adhocSanctionedAmount: number | null;
  adhocAvailableAmount: number | null;
  adhocEffectiveUpto: string | null;
  adhocEffective: boolean;
  createdBy: string;
  checkerRemarks: string;
  makerRemarks: string;
  draft: boolean;
  blocked: boolean;
  freeze: boolean;
  inactiveReason: string | null;
  isDisabled: boolean;
  createdOn: number;
  updatedOn: number;
};

export type ListApprovedLimitsV2Response = {
  aggregateLimit: AggregateLimitV2;
  nonAggregateLimit: NonAggregateLimitV2[];
  normalAvailableAmount: number;
  adhocAvailableAmount?: number;
  normalUtilizedAmount?: number;
  adhocUtilizedAmount?: number;
};

export type ListApprovedLimitsV2ReduxState = {
  loading?: boolean;
  data?: ListApprovedLimitsV2Response | null;
  error?: any;
};

export type ListApprovedLimitsV2Request = {
  payload: string;
  type: string;
};

export type LatestVersionLimitsV2ReduxState = {
  loading?: boolean;
  data?: ListApprovedLimitsV2Response | null;
  error?: any;
};

export type LatestVersionLimitsV2Request = {
  payload: string;
  type: string;
};

export type NonAggregateLimitPayload = {
  externalId: string | null;
  productTypeId: string;
  normalSanctionedAmount: number;
  normalOperativeAmount: number;
  normalEffectiveUpto: string;
  adhocSanctionedAmount?: number | null;
  adhocEffectiveUpto?: string | null;
  makerRemarks: string;
};
export type NonAggregateLimitUpdatePayload = {
  externalId: string | null;
  productTypeId: string;
  normalSanctionedAmount: number;
  normalOperativeAmount: number;
  normalEffectiveUpto: string;
  adhocSanctionedAmount?: number | null;
  adhocEffectiveUpto?: string | null;
  freeze: boolean | string;
  makerRemarks: string;
};

export type CreateDraftLimitV2Payload = {
  currencyId: string;
  normalSanctionedAmount: number;
  normalOperativeAmount: number;
  normalEffectiveUpto: string;
  adhocSanctionedAmount?: number | null;
  adhocEffectiveUpto?: string | null;
  nonAggregateLimit?: NonAggregateLimitPayload;
};

export type CreateDraftLimitV2Request = {
  payload: {
    customerExternalId: string;
    data: CreateDraftLimitV2Payload;
  };
  type: string;
};

export type CreateDraftLimitV2Response = {
  aggregateLimit: AggregateLimitV2;
  nonAggregateLimit: NonAggregateLimitV2[];
};

export type CreateDraftLimitV2ReduxState = {
  loading?: boolean;
  data?: CreateDraftLimitV2Response | null;
  error?: any;
};

export type PublishLimitV2Payload = {
  currencyId: string;
  normalSanctionedAmount: number;
  normalOperativeAmount: number;
  normalEffectiveUpto: string;
  adhocSanctionedAmount?: number | null;
  adhocEffectiveUpto?: string | null;
  makerRemarks: string;
};

export type PublishLimitV2Request = {
  payload: {
    customerExternalId: string;
    data: PublishLimitV2Payload;
  };
  type: string;
};

export type PublishLimitV2Response = {
  aggregateLimit: AggregateLimitV2;
  nonAggregateLimit: NonAggregateLimitV2[];
};

export type PublishLimitV2ReduxState = {
  loading?: boolean;
  data?: PublishLimitV2Response | null;
  error?: any;
};

export type UpdateDraftLimitV2Payload = {
  currencyId: string;
  normalSanctionedAmount: number;
  normalOperativeAmount: number;
  normalEffectiveUpto: string;
  adhocSanctionedAmount?: number | null;
  adhocEffectiveUpto?: string | null;
  makerRemarks?: string;
  /** Aggregate-level freeze/unfreeze when present (no nonAggregateLimit). */
  freeze?: boolean | string;
  nonAggregateLimit?: NonAggregateLimitUpdatePayload;
};

export type UpdateDraftLimitV2Request = {
  payload: {
    customerExternalId: string;
    data: UpdateDraftLimitV2Payload;
  };
  type: string;
};

export type UpdateDraftLimitV2Response = {
  aggregateLimit: AggregateLimitV2;
  nonAggregateLimit: NonAggregateLimitV2[];
};

export type UpdateDraftLimitV2ReduxState = {
  loading?: boolean;
  data?: UpdateDraftLimitV2Response | null;
  error?: any;
};

export type ApproveLimitV2Payload = {
  checkerRemarks: string;
};

export type ApproveLimitV2Request = {
  payload: {
    customerExternalId: string;
    data: ApproveLimitV2Payload;
  };
  type: string;
};

export type ApproveLimitV2ReduxState = {
  loading?: boolean;
  data?: any;
  error?: any;
};

export type RejectLimitV2Payload = {
  checkerRemarks: string;
};

export type RejectLimitV2Request = {
  payload: {
    customerExternalId: string;
    data: RejectLimitV2Payload;
  };
  type: string;
};

export type RejectLimitV2ReduxState = {
  loading?: boolean;
  data?: any;
  error?: any;
};

export type DeleteLimitV2Request = {
  payload: string;
  type: string;
};

export type DeleteLimitV2ReduxState = {
  loading?: boolean;
  data?: any;
  error?: any;
};

export type DeleteLimitV2ByExternalIdRequest = {
  payload: {
    customerExternalId: string;
    borrowerLimitExternalId: string;
  };
  type: string;
};

export type DeleteLimitV2ByExternalIdReduxState = {
  loading?: boolean;
  data?: any;
  error?: any;
};

/** PATCH body for `/customers/{id}/limitsV2/freeze` and `.../unfreeze`. */
export type AggregateLimitV2FreezeUnfreezePayload = {
  inactiveReason: string;
};

export type FreezeLimitV2Request = {
  payload: {
    customerExternalId: string;
    data: AggregateLimitV2FreezeUnfreezePayload;
  };
  type: string;
};

export type FreezeLimitV2ReduxState = {
  loading?: boolean;
  data?: any;
  error?: any;
};

export type UnfreezeLimitV2Request = {
  payload: {
    customerExternalId: string;
    data: AggregateLimitV2FreezeUnfreezePayload;
  };
  type: string;
};

export type UnfreezeLimitV2ReduxState = {
  loading?: boolean;
  data?: any;
  error?: any;
};
